<template>
  <v-dialog
    v-if="dialog"
    v-model="dialog"
    v-permission="['tag-create']"
    max-width="500px"
    :class="$options.name"
  >
    <tag-edit-form
      ref="form"
      :item="item"
      :loading="loading"
      @onRemove="$emit('onRemove', $event)"
      @onSubmit="$emit('onSubmit', $event)"
      @close="$emit('close')"
    />
  </v-dialog>
</template>

<script>

import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import TagEditForm from '@/views/references/tags/components/TagEditForm.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'tag-edit-dialog',

  components: { TagEditForm },

  mixins: [DialogBusMixin],

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    item: null,
  }),

  computed: {
    ...mapState('tags', ['single']),
  },

  methods: {
    ...mapActions(['showNotify']),
    ...mapActions('tags', ['getItem']),

    beforeOpen({ item }) {
      this.item = item || null;
    },
  },
};

</script>
